import { render, staticRenderFns } from "./UnsupportedBrowser.vue?vue&type=template&id=79a11292&scoped=true"
import script from "./UnsupportedBrowser.vue?vue&type=script&lang=js"
export * from "./UnsupportedBrowser.vue?vue&type=script&lang=js"
import style0 from "./UnsupportedBrowser.vue?vue&type=style&index=0&id=79a11292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a11292",
  null
  
)

export default component.exports